import { axiosApi } from "../../../../../api/dbAxios";

export const updateUserRole = async (
  id: string | number,
  name: string,
  email: string,
  team: number | null,
  right_id: number,
) => {
  const body = {
    user: {
      email,
      name,
    },
    team: team ?? null,
    right_id,
  };

  try {
    const response = await axiosApi.patch(`/roles/${id}/`, body);
    return response.data;
  } catch (error) {
    console.error("Error updating user role:", error);
    return [];
  }
};